import { useGetCampaignApiV1Suspense } from "@/api/__generated__/api.schema";
import { CAMPAIGN_INFO } from "@/constants/campaign";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";

export function useCampaignInfo(id: string) {
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { item },
    },
  } = useGetCampaignApiV1Suspense(workspaceId, id);

  return {
    ...item,
    meta: Object.keys(CAMPAIGN_INFO).includes(id) ? CAMPAIGN_INFO[id as keyof typeof CAMPAIGN_INFO] : null,
  };
}
